<template>
    <!-- contents -->
    <div>
        <div class="grid_wrap mt25">
            <div class="sub_tit">{{$t('FIELD.GLOBAL.BASIC.INFO')}}</div>
        </div>
        <table class="create_table">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>{{$t('FIELD.LOCALE.RESOURCE.TYPE')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <select class="slt_white w100" v-model="resType" :disabled="viewMode" @change="changeResType">
                            <option value selected>{{$t('FIELD.GLOBAL.OPTION.DETAIL.NAME')}}</option>
                            <option v-for="type in pResTypes" :key="type.code" :value="type.code">{{ type.codeName }}</option>
                        </select>
                    </td>
                    <th>{{$t('FIELD.GLOBAL.USE')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <select class="slt_white w100" v-model="useYn">
                            <option value="Y" selected>{{$t('FIELD.GLOBAL.YES')}}</option>
                            <option value="N">{{$t('FIELD.GLOBAL.NO')}}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.LOCALE.RESOURCE.ID')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" ref="resId" v-model="resId" :disabled="viewMode" 
                                   maxlength="50" v-clearable />
                        </span>
                    </td>
                    <th>{{$t('FIELD.LOCALE.RESOURCE.NAME')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" ref="resNm" v-model="resNm" 
                                   maxlength="80" v-clearable />
                            <i class="clearable_clear">X</i>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="btn_wrap topLine"></div>
        <!-- //detail_Resource Typ -->

        <!-- LabelSetting tit -->
        <div class="grid_wrap mt25">
            <div class="sub_tit">{{$t('FIELD.ADMIN.LABEL.SETTING')}}</div>
            <div class="btn_wrap" v-if="this.sysAdmYn == 'Y'">
                <a href="JavaScript:" class="btn_white" @click="localeCopy()">{{$t('BUTTON.GLOBAL.COPY')}}</a>
            </div>
        </div>
        <!-- //LabelSetting tit -->
        <!-- LabelSettinge list-->
        <table class="scroll_table">
            <colgroup>
                <col width="15%" />
                <col width="*" />
            </colgroup>
            <thead>
                <th width="15%">{{$t('FIELD.GLOBAL.LANGUAGE')}}</th>
                <th width="*">{{$t('FIELD.LOCALE.RESOURCE.NAME')}}</th>
            </thead>
            <tbody>
                <tr v-for="locale in localeList" :key="locale.locale" @change="changeLocale(locale)">
                    <td class="tC w13_5">[{{ locale.locale }}] {{ locale.localeNm }}</td>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" placeholder v-model="locale.labelInfo" maxlength="1300" v-clearable />
                            <i class="clearable_clear">X</i>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- //Label Setting list -->
        <!-- page btn -->
        <div class="btn_wrap_full">
            <a href="JavaScript:" class="btn_white size_full" @click="goList()" title>{{$t('BUTTON.GLOBAL.LIST')}}</a>
            <div class="btn_right" v-if="this.sysAdmYn == 'Y'">
                <a href="JavaScript:" v-if="viewMode" class="btn_white" @click="resDelete()" title>{{
                    $t('BUTTON.GLOBAL.DELETE')
                }}</a>
                <a href="JavaScript:" class="btn_blue" @click="resSave()" title>{{$t('BUTTON.GLOBAL.SAVE')}}</a>
                <a href="JavaScript:" class="btn_blue" @click="applySystem()">{{$t('BUTTON.GLOBAL.APPLY.SYSTEM')}}</a>
            </div>
        </div>
    </div>
    <!-- //Label Setting list -->
    <!-- contents -->
</template>

<script>
import Vue              from 'vue';
import axios            from 'axios';
import qs               from 'query-string';
import _                from 'lodash';
import $                from 'jquery';
import constants        from '@/constants';
import SDLLocale        from '@/mixin/SDLLocale';
import { SDLUtil }      from '@/utils';
import { EventBus }     from '@/utils/EventBus';
import SKPBreadcrumbs   from '~vb/main/SKPBreadcrumbs';
import api              from '@/service';

export default {
    name: 'ResrcAdminDetail',
    props: {
        pResTypes: { type: Array, default: [] },
        pResId: { type: String, default: '' },
    },
    data() {
        return {
            isLoading: true,
            viewMode: false, // 'create or modify'
            resType: '',
            resId: '',
            resNm: '',
            useYn: 'Y',
            localeList: [],
            updateLocales: [],
            sysAdmYn:'',
        };
    },
    computed: {},
    watch: {},
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    methods: {
        initLoad() {
            if (this.pResId) {
                // 수정모드
                this.dataLoad();
            } else {
                // 신규모드
                // 초기화
                return axios
                    .get(`${SDLUtil.API_URL}/basis/admin/system/resource/resNewLocales.skp`, {})
                    .then(resp => {
                        this.localeList = resp.data;
                        this.list2Str(this.localeList);
                    })
                    .catch(err => {
                        Vue.$log.error(err);
                    });
            }
        },
        dataLoad() {
            const data = { resId: this.pResId };
            return axios
                .get(`${SDLUtil.API_URL}/basis/admin/system/resource/resInfo.skp`, { params: data })
                .then(resp => {
                    let resInfo = resp.data;
                    this.resType = resInfo.resType;
                    this.resNm = resInfo.resNm;
                    this.useYn = resInfo.useYn;
                    this.localeList = resInfo.localeInfo;
                    this.list2Str(this.localeList);
                })
                .catch(err => {
                    Vue.$log.error(err);
                });
        },
        // aftMode: 1=goList, 2=refresh
        saveExec(url, formData, msg, aftMode) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(url, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    if (resp.data.result == 1) {
                        this.viewMode = true;
                        Vue.toasted.show(
                            SDLUtil.getMsgProp(msg), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                        if (aftMode == 1) {
                            EventBus.$emit('goRsrcList', 1);
                        }
                    } else {
                        SDLUtil.alert('Error occured ' + resp.data.result);
                    }
                })
                .catch(err => {
                    this.searchStatus = 'error';
                    SDLUtil.showLoadingBar(false);
                });
        },
        applySystem() {
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.APPLY.SYSTEM',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/resource/resApplySystem.skp`;
                    this.saveExec(url, {}, 'MESSAGE.SYSTEM.APPLY.SUCCESS', 0);
                },
            });
        },
        resValidateion() {
            let bRes = true;
            let valids = [this.resType, this.resId, this.resNm, this.useYn];
            let titles = ['Resource Type', 'Resource ID', 'Resource Name', 'Use'];
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    bRes = false;
                    SDLUtil.alert('Empty value of [' + titles[idx] + ']');
                    return;
                }
            });
            return bRes;
        },
        saveParams(exclude = []) {
            let params = {
                updateMode: this.viewMode,
                resType: this.resType,
                resId: this.resId,
                resNm: this.resNm,
                useYn: this.useYn,
                localeInfo: this.updateLocales,
            };
            return params;
        },
        resSave() {
            const fData = this.saveParams();
            if (!this.resValidateion()) {
                return;
            }
//            console.log('save.fData ==> ', fData);
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/resource/resAdminSave.skp`;
                    this.saveExec(url, fData, 'MESSAGE.SUCCESS.SAVED', 0);
                },
            });
        },
        resDelete() {
            const fData = { resId: this.resId };
            SDLUtil.confirm({
                msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                title: 'BUTTON.GLOBAL.DELETE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/resource/resAdminDelete.skp`;
                    this.saveExec(url, fData, 'MESSAGE.SUCCESS.DELETED', 1);
                },
            });
        },
        changeResType() {
            if (!this.redId) {
                this.resId = this.resType + '.';
                this.$refs.resId.focus();
            }
        },
        changeLocale(loc) {
            let str1 = loc.locale;
            let str2 = loc.labelInfo;
            let newList = [];
            this.updateLocales.forEach(elm => {
                let spl = elm.split('::');
                let code = spl[0];
                if (code == str1) {
                    elm = str1 + '::' + str2;
                }
                newList.push(elm);
            });
            this.updateLocales = newList;
        },
        localeCopy() {
            // Copy
            let first = this.localeList[0].labelInfo;
            let nList = [];
            this.localeList.forEach(elm => {
                elm.labelInfo = first;
                nList.push(elm);
            });
            this.localeList = nList;
            this.updateLocales = [];
            this.list2Str(nList);
        },
        list2Str(orgs) {
            orgs.forEach(elm => {
                let str1 = elm.locale;
                let str2 = elm.labelInfo;
                if (str2 == undefined || str2 == 'undefined') str2 = '';
                this.updateLocales.push(str1 + '::' + str2);
            });
        },
        goList() {
            EventBus.$emit('go-back-rsrc-list', 1);
        },
    }, // methods
    created() {
    },
    mounted() {
        this.resId = this.pResId;
        this.viewMode = this.pResId ? true : false;
        if (this.viewMode) this.$refs.resNm.focus();
        else this.$refs.resId.focus();
        this.initLoad();
        this.sysAdmYn = SDLUtil.isRoleExist(`${constants.SYSTEM_ADMIN}`) ? 'Y' : 'N' ;
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/resource/ResourceAdminView.vue